import React from "react";
import dayjs from "dayjs";
import Config from "../util/config";
import { Price } from "../service/prices";

export interface Props {
  price: Price | null;
  hideSection: Boolean;
}
const PriceInfo = (props: Props): JSX.Element => {
  const advancedFormat = require("dayjs/plugin/advancedFormat");
  dayjs.extend(advancedFormat);
  const currencySymbol = Config.get("currency_symbol", "£");
  const price = props?.price?.rate ?? Number((Config.get("basePrice", 0) / 7)) ?? 0;
  const nights = props?.price?.nights ?? 1;
  if (props.hideSection) {
    return null;
  }
  return (
    <div id="price-info">
      {Config.get('showStayAvailableSection', 'yes') === 'yes' && props.price !== null && (
        <div id="stay-available">
          <p id="nights-stay">
            Your {nights} night stay is <em>available</em>
          </p>
          <p id="stay-dates">
            <span id="price-info-start">
              {dayjs(props.price.start_date, "YYYY-MM-DD").format(
                Config.get("priceInfoDateFormat", "Do MMMM YYYY"),
              )}
            </span>
            -
            <span id="price-info-end">
              {dayjs(props.price.start_date, "YYYY-MM-DD")
                .add(nights, "days")
                .format(Config.get("priceInfoDateFormat", "Do MMMM YYYY"))}
            </span>
          </p>
        </div>
      )}

        <div id="prices">
            {props.price !== null && (
                <>
                    {props.price.discount !== 0 && (
                        <p id="old-rate">
                            <s className="old-price">
                                {currencySymbol}
                                {props.price.rate + props.price.discount}
                            </s>
                        </p>
                    )}
                    <p id="rate">
                        {currencySymbol}
                        {Number(props.price.rate).toFixed(2)}
                    </p>
                    <p id="book-now-text">
                        {Config.get("priceText", "Book now to secure your dates at only")}
                    </p>
                </>
            )}
            {Config.get("basePrice", 0) > 0 && (
              <>
                {!props.price && (
                  <p id="from-rate">
                    From{" "}
                    <span id="from-price">
                      {currencySymbol}
                      {(Math.ceil((Config.get("basePrice", 0) / 7) * 100) / 100).toFixed(2)}
                    </span>{" "}
                    <span id="post-from-price-text">per night</span>
                  </p>
                )}
                <p id="pppn-text" className={props.price ? "has-price" : "no-price"}>
                  <span id="pre-pppn">{Config.get("pppnPreText", "")}</span>
                  &nbsp;
                  <span id="pppn">
                    {currencySymbol}
                    {(
                      Math.ceil((price / Config.get("sleeps", 1) / nights) * 100) / 100
                    ).toFixed(2)}
                  </span>
                  &nbsp;
                  <span
                    dangerouslySetInnerHTML={{
                      __html: Config.get("pppnPostText", "pppn"),
                    }}
                    id="post-pppn"
                  />
                </p>
              </>
            )}
        </div>
    </div>
  );
};

export default PriceInfo;
